module.exports = __webpack_public_path__ + "img/36.2.TN.a408972c.png";